var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","dir":"rtl"}},[_c('pageHeader'),_c('secVideo'),_c('secVideo2'),_c('secVideo3'),_c('secVideo4'),_c('secImage'),_c('login-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }